import React from 'react';

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useDefaultSearchParams } from '../../hooks/useDefaultSearchParams';

import { knowledgeBaseSortOptions } from '../../constants/sort';

import PageHeader from '../../components/PageHeader';
import BasesIndex from './BasesIndex/BasesIndex';

const BasesPage = () => {
    useDefaultSearchParams({ checkPage: true, checkSort: true });

    useDocumentTitle('Knowledge Bases');

    return (
        <div className="page-position flex flex-col bg-neutral-50 overflow-y-auto hide-scrollbar">
            <PageHeader
                title={
                    <>
                        Welcome to <br className="hidden min-[400px]:block" />
                        your Knowledge Base
                    </>
                }
                description="Explore all of the context available to your chatbots and agents"
                backgroundColor="white"
                sortOptions={knowledgeBaseSortOptions}
            />

            <div className="w-full px-5 xs:px-6 lg:px-8 pt-5 lg:pt-6 pb-6 lg:pb-9">
                <BasesIndex />
            </div>
        </div>
    );
};

export default BasesPage;
